import React, { useCallback } from 'react';
import { format, parseISO } from 'date-fns';

import ControlesNotaFiscal from '../ControlesNotaFiscal';
import { INotafiscal } from '../../pages/Nota';
import { SITUACAO_NOTA_FISCAL } from '../../utils/funcoes';

type ItensNotaProps = {
  Item: INotafiscal;
};

const ItemTabela: React.FC<ItensNotaProps> = ({ Item }) => {
  const {
    CprCodigo,
    nome,
    descricao,
    CprDataPag,
    FormaPagto,
    NfeSituacao,
    NfeNumero,
    NumeroNF,
    vlrFormatado,
    NfeMessage,
  } = Item;
  // const dados: ISituacaoNota = {
  //   NfeSituacao,
  //   NfeNumero,
  //   NumeroNF,
  //   NfeCodigoVerificacao,
  //   NfeLinkNFSe,
  // };

  // const baixarPDF = useCallback(async () => {
  //   try {
  //     await api.get(`consultaNFSE/${NfeNumero}`);
  //   } catch (error) {
  //     const mensagemErro = getResponseErrors(error);
  //     addToast({
  //       title: 'Não foi possível baixar PDF',
  //       type: 'error',
  //       description: mensagemErro,
  //     });
  //   }
  //   // this.removeCarregandoElemento(botao, elementoBotao);
  //   /* $('#ModalNotaFiscalCadastro').modal('hide'); */
  // }, [NfeNumero, addToast]);

  const montaSituacao = useCallback((): string => {
    if (NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA) {
      return 'text-success';
    }
    if (NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.CANCELADO) {
      return 'text-cinza text-line-through';
    }
    if (FormaPagto.includes('Cart')) {
      return 'text-danger';
    }
    return '';
  }, [FormaPagto, NfeSituacao]);

  if (Item)
    return (
      <tr
        key={`${CprCodigo.toString()}-${NfeNumero}`}
        className={montaSituacao()}
      >
        <td>{nome}</td>
        <td>{descricao}</td>
        <td style={{ width: '7%', textAlign: 'end' }}>{vlrFormatado}</td>
        <td style={{ width: '8%', textAlign: 'center' }}>
          {format(parseISO(CprDataPag), 'dd/MM/yyyy')}
        </td>
        <td>{FormaPagto}</td>
        <td title={NfeMessage || ''} style={{ width: '7%' }}>
          {NfeSituacao || 'Não gerada'}
        </td>
        <td style={{ width: '4%' }}>{NfeNumero || ''}</td>
        <td style={{ width: '7%' }}>{NumeroNF || ''}</td>
        <td>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minWidth: '75px',
              border: '0px',
            }}
          >
            <ControlesNotaFiscal
              cprCodigo={CprCodigo}
              nfeId={Item.NfeId}
              dadosNota={Item}
              podeCancelar
            />
          </div>
          {/* {/* <a
                  href={`https://voltaredonda.simplissweb.com.br/contrib/app/nfse/relatorio?cnpj=31975850000139&ser=E&inum=${NumeroNF}&icod=${NfeCodigoVerificacao}`}
                  title="Ver NF"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: '34px' }}
                  className={
                     NumeroNF && !NfeLinkNFSe
                        ? 'btn btn-sm btn-outline-primary'
                        : 'd-none'
                  }
               >
                  <i className="fa fa-file-pdf-o" aria-hidden="true" />
               </a> * / }
          <a
            href={NfeLinkNFSe || ''}
            title="Ver NF"
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '34px' }}
            className={
              NumeroNF && NfeLinkNFSe && NfeLinkNFSe.match(/drive.google/)
                ? 'btn btn-sm btn-outline-primary'
                : 'd-none'
            }
          >
            <FaFilePdf />
          </a>
          {/* <a
                  href={`https://voltaredonda.simplissweb.com.br/contrib/app/nfse/relatorio?cnpj=31975850000139&ser=E&inum=${NumeroNF}&icod=${NfeCodigoVerificacao}`}
                  title="Ver NF"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: '34px' }}
                  className={
                     NumeroNF && !NfeLinkNFSe.match(/drive.google/)
                        ? 'btn btn-sm btn-outline-primary'
                        : 'd-none'
                  }
               >
                  <i className="fa fa-file-pdf-o" aria-hidden="true" />
               </a> * /}
          <button
            type="button"
            id={`link${NfeNumero}`}
            title="Gerar PDF"
            className={
              NumeroNF &&
              NfeLinkNFSe !== null &&
              !NfeLinkNFSe.match(/drive.google/)
                ? 'btn btn-sm btn-outline-success'
                : 'd-none'
            }
            onClick={() => baixarPDF()}
          >
            <FaDownload id={`ilink${NfeNumero}`} />
          </button>

          <span
            className={
              (!NfeSituacao ||
                NfeSituacao === 'PROCESSANDO' ||
                NfeSituacao === 'Processando') &&
              NfeNumero
                ? 'btn btn-sm btn-outline-primary'
                : 'd-none'
            }
          >
            <FaSpinner />
            <span className="sr-only">Loading...</span>
          </span>

          <button
            type="button"
            id={CprCodigo.toString()}
            className={
              (!NumeroNF && !NfeNumero) || NfeSituacao === 'REJEITADO'
                ? 'btn btn-sm btn-outline-primary'
                : 'd-none'
            }
            onClick={() => MontaRPS(CprCodigo.toString())}
          >
            <FaShareSquare id={`i${CprCodigo}`} />
          </button>
          */}
        </td>
      </tr>
    );
  return <span />;
};

export default ItemTabela;
